/**
 * The five-step beginner reading path shown on the LARP hub (§ T-14).
 * `ids` are language-neutral article ids (frontmatter `id`), resolved to
 * the current language's slug and title at render time — the same
 * mechanism the homepage's start-here block uses, so neither list can
 * drift into linking the other language's slug.
 */
export const READING_PATH = {
  de: [
    {
      ids: ["was-ist-larp"],
      text: "Fang bei der Grundfrage an: Was passiert auf einem LARP-Event, und warum ist das etwas anderes als Theater oder Cosplay?",
    },
    {
      ids: ["rollen-im-larp", "it-und-ot"],
      text: "Dann die zwei Begriffe, die auf jedem Con fallen: Wer ist SC, NSC oder Spielleitung — und was heißt es, IT oder OT zu sein?",
    },
    {
      ids: ["charaktererstellung"],
      text: "Jetzt wird es persönlich: Aus einer Idee wird eine Figur mit Namen, Herkunft und einem Grund, überhaupt loszuziehen.",
    },
    {
      ids: ["gewandung-und-ausruestung", "ausruestung-einstieg-bis-prestige", "waffen-und-sicherheit"],
      text: "Erst danach lohnt sich das Einkaufen: Gewandung, Rüstung und Waffen — was dein Charakter wirklich braucht und was warten kann.",
    },
    {
      ids: ["community-und-vorbereitung"],
      text: "Zum Schluss die Praxis: Packliste, Anreise, die ungeschriebenen Regeln und die No-Gos, die du am ersten Abend kennen solltest.",
    },
  ],
  en: [
    {
      ids: ["was-ist-larp"],
      text: "Start with the basic question: what actually happens at a LARP event, and how is it different from theatre or cosplay?",
    },
    {
      ids: ["rollen-im-larp", "it-und-ot"],
      text: "Then the two bits of jargon you will hear at every event: who is a player, an NPC or a game master — and what being in or out of character means.",
    },
    {
      ids: ["charaktererstellung"],
      text: "Now it gets personal: an idea turns into a character with a name, a background and a reason to leave home at all.",
    },
    {
      ids: ["gewandung-und-ausruestung", "ausruestung-einstieg-bis-prestige", "waffen-und-sicherheit"],
      text: "Only then is it worth shopping: costume, armour and weapons — what your character really needs and what can wait.",
    },
    {
      ids: ["community-und-vorbereitung"],
      text: "Finally the practical side: the packing list, getting there, the unwritten rules and the no-gos worth knowing on your first evening.",
    },
  ],
};
